import { Box, LinearProgress } from '@mui/material';

// ----------------------------------------------------------------------

/** Suspense fallback while a lazily-loaded page chunk arrives. */
export default function LoadingScreen() {
  return (
    <Box
      sx={{
        right: 0,
        bottom: 0,
        zIndex: 9998,
        width: '100%',
        height: '100%',
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
      }}
    >
      <LinearProgress color="primary" sx={{ width: 1, maxWidth: 360 }} />
    </Box>
  );
}
